"use client";

import { useQuery } from "@tanstack/react-query";

const HEALTH_QUERY = `query { health { data { up } } }`;

async function checkHealth(): Promise<boolean> {
  const res = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/graphql`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query: HEALTH_QUERY }),
  });
  if (!res.ok) return false;
  const json = await res.json();
  return json?.data?.health?.data?.up === true;
}

export function usePyloStatus() {
  const { isFetched, isError, data } = useQuery({
    queryKey: ["health"],
    queryFn: checkHealth,
    retry: 1,
    refetchInterval: 30_000,
  });

  return {
    isUnreachable: isFetched && (isError || data === false),
  };
}
